/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import {css} from 'styled-components';
import {darken} from 'polished';
import Colors from '../../constants/Colors';
import {FiraSansBold} from '../Text';
import {Breakpoints} from "../../constants/Breakpoints";

const primaryMixin = css`
  color: ${Colors.WHITE};
  background-color: ${Colors.BLUE};
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
   margin: 0px 10px 0px 0px;

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background-color: ${darken(0.1, Colors.BLUE)};
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
  }
  &:active:not(:disabled) {
    background-color: ${darken(0.2, Colors.BLUE)};
  }
  
  @media (min-width: ${Breakpoints.lg}) {
     margin: 0;
  }
`;

const outlinePrimaryMixin = css`
  color: ${Colors.WHITE};
  border: 1px ${({ dashed }) => (dashed ? 'dashed' : 'solid')}
    ${Colors.BLUE};
  padding: 4px 16px;
  text-transform: none;
  ${FiraSansBold}

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    color: white;
    border-color: ${Colors.BLUE};
    background: ${Colors.BLUE};
  }
  &:active:not(:disabled) {
    background-color: ${darken(0.2, Colors.BLUE)};
  }
`;

const grayTextMixin = css`
  padding: 8px 0;
  color: ${Colors.GRAY[0]};

  &:active:not(:disabled) {
    color: ${Colors.GRAY[3]};
  }
`;

const noBorderPrimaryMixin = css`
  color: ${Colors.BLUE};
  padding: 6px 16px;
  ${FiraSansBold}
  text-transform: none;

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    color: ${Colors.PRIMARY};
  }
  &:active:not(:disabled) {
    color: ${Colors.PRIMARY};
  }
`;

const forthMixin = css`
  padding: 0.75rem 0.95rem;
  color: ${Colors.GRAY[6]};
`;

// Size mixin
const smallMixin = css`
  height: 32px;
`;

export {
  primaryMixin,
  outlinePrimaryMixin,
  grayTextMixin,
  noBorderPrimaryMixin,
  smallMixin,
  forthMixin,
};
